import React, { useRef, useEffect, useState } from "react";
import "./App.css"; // Import your main CSS file (if needed)
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Profile from "./components/Profile/000Profile";
import Blog from "./components/Blog/Blog";
import Resume from "./components/Resume/Resume";
import Connect from "./components/Connect/Connect";
import Projects from "./components/Projects/Projects";
import BackToTopButton from "./components/misc/BackToTopButton";
import Foot from "./components/misc/Foot";
import LoadingBar from "react-top-loading-bar";
import ChatBotFullRoute from "./components/ChatBot/ChatBotRoute";

function App() {
    const ref = useRef(null);
    const location = useLocation();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const handleStart = () => {
            setLoading(true);
            ref.current.continuousStart();
        };

        const handleComplete = () => {
            ref.current.complete();
            setLoading(false);
        };

        // Start loading when the route changes
        handleStart();

        // Simulating loading time based on content length
        const loadTime = location.pathname === "/profile" ? 2000 : 800; // Customize load time for each route
        const timer = setTimeout(handleComplete, loadTime);

        return () => clearTimeout(timer); // Cleanup the timer on component unmount
    }, [location]);

    return (
        <>
            <LoadingBar
                color="orange"
                height={3}
                waitingTime={1000}
                ref={ref}
            />
            <Navbar />
            <Routes>
                <Route path="/" element={<Navigate to="/profile" replace />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/resume" element={<Resume />} />
                <Route path="/connect" element={<Connect />} />
                <Route path="/chatbot" element={<ChatBotFullRoute />} />
            </Routes>
            <BackToTopButton />
            <Foot />
        </>
    );
}

export default App;

// database for softocdding
